// 清理空间——流程
const HuaWeiRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `space/huawei/index${i + 1}`,
  name: `spaceHuaWeiIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/space/huawei/index${i + 1}.vue`)
}))
const MiRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `space/mi/index${i + 1}`,
  name: `spaceMiIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/space/mi/index${i + 1}.vue`)
}))
const VivoRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `space/vivo/index${i + 1}`,
  name: `spaceVivoIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/space/vivo/index${i + 1}.vue`)
}))

import spaceIndex from '@/views/phoneSettings/space/index.vue'



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'space/index',
      name: 'spaceIndex',
      component: spaceIndex,
    },
    // 清理空间——主流程，开始
    ...HuaWeiRoutes,
    ...MiRoutes,
    ...VivoRoutes,


  ],
};
